import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;
  blacklistName: string;

  handleEditBlacklistNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleRenameBlacklist(): void;
}

const EditBlacklistNameDialog: React.FC<Props> = ({
  open,
  loading,
  blacklistName,
  handleEditBlacklistNameChange,
  handleClose,
  handleRenameBlacklist,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('changeBlacklistNameTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <PaiTextField
          value={blacklistName}
          placeholder={t('changeBlacklistNamePlaceholder')}
          variant={'background'}
          onChange={handleEditBlacklistNameChange}
        />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} action={handleRenameBlacklist} size={'small'} border={'rounded'} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default EditBlacklistNameDialog;
